export default __webpack_public_path__ + "static/media/memo_doc_word.9bbba4e5.svg";